import { createContext } from 'react'

export const defaultSelectedAncestorNode = []
                                  
const SelectedAncestorNodeContext = createContext({selectedAncestorNode:defaultSelectedAncestorNode, setSelectedAncestorNode: () => {}}) 

export default SelectedAncestorNodeContext